import React, { Component } from 'react';
import {StripeProvider, Elements} from 'react-stripe-elements';
import _ from 'underscore';
import moment from 'moment';

import StripeCard from './components/StripeCard.js'

class Dashboard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      newCardComplete: false,
      error: null,
      cardError: null,
      loading: false,
      schoolConfirm: false
    }
    var order = this.props.order
    if(order.items.length + order.prevItems.length === 0)
      window.location.href = '#/dashboard';
  }

  componentWillMount(){
    if(this.props.order.id)
      window.location.href = '#/done';
  }

  getItems(){
    var order = this.props.order
    return order.items.concat(order.prevItems)
      .map((item, i)=>
        <tr key={i}>
          <td>
            {item.name}
            { order.type === 'coffee' ? (' - ' + item.size) : null }
            { order.type === 'coffee' ? null :
              <span> - <span style={{background: 'yellow'}}>
                { item.person && item.person.name }
              </span> - Class: {item.person && item.person.classroom && item.person.classroom.name }</span>
            }
          </td>
          {item.time ? <td>{item.time}</td> : null}
          <td>${this.toCurrency(item.price)}</td>
          { order.type === 'coffee' ? null :
            <td>{item.quantity}</td> }
        </tr>
      )
  }

  getSubTotal(){
    var order = this.props.order
    return order.items.concat(order.prevItems)
      .reduce((x, y)=>x+ y.price*y.quantity, 0)
  }

  getSurcharge(){
    var stot = this.getSubTotal();
    if(this.props.order.payment === 'poli')
      return stot * 0.01
    return (stot + 0.3)/(1-0.029) - stot
  }

  toCurrency(num){
    if(num % 0.01 === 0 || num % 0.07 === 0) return num;
    return (Math.ceil(num * 100) / 100).toFixed(2)
  }

  getTotal(){
    return this.getSurcharge() + this.getSubTotal();
  }

  getSurchargeName(){
    return this.props.order.payment === 'poli' ?
      'Internet Banking' :
      'Credit / Debit Card';
  }

  setCardComplete(){
    this.setState({newCardComplete: true});
  }

  handleRadio(e){
    var order = this.props.order;
    order.payment = e.target.value;
    this.props.updateOrder(order);

    if(e.target.value === 'newcard')
      this.setState({newCardComplete: false})
  }

  handleNext(e){
    e.preventDefault();

    if(this.nextDisabled() || this.state.loading)
      return;

    if(!this.props.phone)
      return alert('Please enter your phone number - we need this, in case there is any issues with your order.');

    if(!this.state.schoolConfirm && this.props.order.type !== 'coffee')
      return alert('Please check the box to confirm the school to which this order will be delivered');

    var order = this.props.order

    this.setState({loading: true});

    if(order.payment === 'newcard')
      this.stripe.createToken().then(res=>{
        if(res.error){
          console.log('err',res.error.message);
          this.setState({
            cardError: res.error.message,
            loading: false
          })
        } else {
          this.sendOrder({
            id: res.token.id,
            last4: res.token.card.last4
          })
        }
      });

    else
      this.sendOrder();
  }

  sendOrder(token){
    var order = this.props.order
    fetch('/api/order', {
      credentials: 'include',
      method: 'POST', // or 'PUT'
      body: JSON.stringify({
        phone: this.props.phone,
        type: order.type,
        token: token && token.id,
        last4: token && token.last4,
        person_id: order.customer.id,
        school_id: order.customer.school.id,
        date: order.date.date,
        time: order.time,
        notes: order.notes,
        items: order.items.concat(order.prevItems).map(item=> ({
            id:item.id,
            count:item.quantity,
            size: item.size_id,
            time: item.time,
            person_id: item.person && item.person.id,
            person_name: item.person && item.person.name
          })
        ),
        payment: order.payment
      }),
      headers: new Headers({
        'Content-Type': 'application/json'
      })
    })
    .then(res => res.ok ? res.json() :
      this.setState({error: 'An error occurred: '+res.statusText, loading: false})
    )
    .then(res => {
      if(res.error)
        this.setState({error: res.error, loading: false})
      else {
        if(this.props.order.payment === 'poli'){
          if(res.Success){
            var token = res.NavigateURL.match(/Token=(.+)$/)
            window.history.pushState(null, null, '/#/poli/cancel/null?token='+token[1])
            window.location.href = res.NavigateURL;
          } else {
            this.setState({error: 'Poli error occurred, please try again later', loading: false})
          }
        }
        else {
          var order = this.props.order;
          order.id = res.id;
          this.props.updateOrder(order);
          if(token && token.last4)
            this.props.setState({savedCard: token.last4})
          window.location.href = '#/done';
        }
      }
    })
  }

  nextDisabled(){
    var order = this.props.order
    return order.items.length + order.prevItems.length < 1;
  }

  goBack(e){
    e.preventDefault();
    window.history.go(-1);
  }

  render() {
    var order = this.props.order,
      schoolsList, schoolConfirm;
      if(order.items.length && order.items[0].type !== 'coffee'){
        schoolsList =
          order.items
            .concat(order.prevItems)
            .map(item => item.person.school.name);
        schoolConfirm = <span>Please confirm - this order will be delivered
            to <span style={{background: 'yellow'}}>{_.uniq(schoolsList).join(", ")}</span>
            <br />
            If this is incorrect, go back to update
            your order, with the 'Add/Edit People' button on the previous step
          </span>
      }

    if(!order.items.length && !order.prevItems.length)
      return null;
    return (
      <div className="">
        <h1>
          Confirm Order {(order.items.length && order.items[0].type) === 'coffee' ? null :
          ( ' for ' + order.date.name ) }
        </h1><br />
        { this.state.error ?
          <div className="alert alert-danger">{this.state.error}</div>
         : null }
        { order.items.length && order.items[0].type === 'coffee' ? (
          <p>{order.customer.name} - {order.customer.school.name}</p>
        ) : (
          <p>{order.prevItems.length ? '' : order.customer.name}</p>
        )}

        <table className="table">
          <thead>
            <tr>
              <th>Item</th>
              { order.type === 'lunch' ? <th>Time</th> : null}
              <th>Price</th>
              { order.type === 'coffee' ? null :
                <th>Quantity</th> }
            </tr>
          </thead>
          <tbody>
            { this.getItems() }
          </tbody>
        </table>

        <br />

        <div className="form-group">
          <label htmlFor="phone" className="col-sm-2 control-label"
            style={{margin: '8px 0px 0px 0px'}}>Phone</label>
          <div className="col-sm-10">
            <input type="text" className="form-control"
              placeholder="Your phone number"
              id="phone"
              value={this.props.phone}
              required
              onChange={(e)=>this.props.setPhone(e.target.value)} />
          </div>
        </div>

        <br />

        { this.props.savedCard ? (
          <div className="radio">
            <label>
              <input type="radio"
                name="payment"
                id="optionsRadios1"
                onChange={this.handleRadio.bind(this)}
                checked={this.props.order.payment === 'saved'}
                value="saved" />
              Saved card - ending {this.props.savedCard}
            </label>
          </div>) : null }
        { this.props.disablePoli ? null : (
          <div className="radio">
            <label>
              <input type="radio"
                name="payment"
                id="optionsRadios2"
                onChange={this.handleRadio.bind(this)}
                checked={this.props.order.payment === 'poli'}
                value="poli" />
              Internet Banking (Pay with POLi)
            </label>
          </div>
        )}
        <div className="radio">
          <label>
            <input type="radio"
              name="payment"
              id="optionsRadios2"
              onChange={this.handleRadio.bind(this)}
              checked={this.props.order.payment === 'newcard'}
              value="newcard" />
            New Credit / Debit Card
          </label>
        </div>

        <br />

        { this.props.order.payment === 'newcard' ?
          <div>
            <div className="alert alert-info">
              Card will be securely saved for future orders
            </div>

            { this.props.stripeKey ? (
              <StripeProvider apiKey={this.props.stripeKey}>
                <Elements>
                  <StripeCard ref={(child) => {
                    if(child && child.state && child.state.stripe)
                      this.stripe = child.state.stripe;
                  }} />
                </Elements>
              </StripeProvider>
            ) : <p>Loading stripe...</p>}

            { this.state.cardError ?
              <div className="alert alert-danger">{this.state.cardError}</div>
             : null }

          </div> : null}

        <div className="text-center">
          <p>{this.getSurchargeName()} Surcharge: ${this.toCurrency(this.getSurcharge())}</p>
          { order.payment === 'poli' ? (
            <a type="button" href="" data-toggle="modal" data-target="#myModal">
              Available Banks
            </a>
          ) : null}
          <h2>Order Total ${this.toCurrency(this.getTotal())}</h2>
          {
            (order.items.length && order.items[0].type) === 'coffee' ?
              null : <h2 style={{marginTop: '-8px', marginBottom: '18px'}}>
                {order.date.name} - {moment(order.date.date).format('D/M/YYYY')}
              </h2>
          }
        </div>



        <div className="modal fade" id="myModal" tabIndex="-1" role="dialog" aria-labelledby="myModalLabel">
          <div className="modal-dialog" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <button type="button" className="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                <h4 className="modal-title" id="myModalLabel">Available Banks</h4>
              </div>
              <div className="modal-body">
                <div className="intrinsic-container intrinsic-container-4x3">
                  <iframe title="banks"
                    src="https://transaction.apac.paywithpoli.com/POLiFISupported.aspx?merchantcode=SS64007731">
                  </iframe>
                </div>
              </div>
            </div>
          </div>
        </div>

        { this.props.order.notes ? (
          <p>
            Notes: {this.props.order.notes}
          </p>
        ) : null }



        { schoolConfirm ?
          <div className="row">
            <div className="col-xs-1">
              <input type="checkbox" id="schoolConfirm"  checked={this.state.schoolConfirm}
                onChange={(e)=>this.setState({ schoolConfirm: e.target.checked })} />
            </div>
            <div className="col-xs-10">
              <label htmlFor="schoolConfirm">{ schoolConfirm }</label>
            </div>
          </div>
        : null }

        <div className="row" style={{marginBottom: '15px'}}>
          <div className="col-xs-6">
            <a href=""
              onClick={this.goBack}
              className="btn btn-default btn-lg btn-block">Back</a>
          </div>

          <div className="col-xs-6">
            <a href="#/done"
              className="btn btn-primary btn-lg btn-block"
              disabled={this.nextDisabled() || this.state.loading}
              onClick={this.handleNext.bind(this)}>
              { this.state.loading ? 'Loading...' : 'Confirm Order' }
            </a>
          </div>
        </div>

      </div>
    );
  }
}

export default Dashboard;



// WEBPACK FOOTER //
// ./src/pages/Confirm.js